<template>
  <div class="">
    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Usuários</h1>
        </div>

        <div class="md-toolbar-section-end">
          <md-field style="margin-right: 1rem">
            <label for="movies">Locais</label>
            <md-select
              id="locais"
              v-model="selectedLocais"
              name="locais"
              multiple
              @md-selected="searchOnTableLocais"
            >
              <md-option
                v-for="local in locais"
                :key="local.id"
                :value="local.id"
              >
                {{ local.nome }}
              </md-option>
            </md-select>
          </md-field>

          <md-field>
            <md-input
              v-model="search"
              placeholder="Busque por nome"
              @input="searchOnTable"
            />
          </md-field>
          <md-button class="md-primary md-raised" @click="searchOnTable">
            Buscar
          </md-button>
          <md-button
            class="md-primary md-raised"
            @click="$router.replace('/usuarios/criar')"
          >
            Cadastrar
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Nome</md-table-head>
        <md-table-head>Nome Completo</md-table-head>
        <md-table-head>E-mail</md-table-head>
        <md-table-head>Nível de acesso</md-table-head>
        <md-table-head>Block</md-table-head>
        <md-table-head>Ações</md-table-head>
      </md-table-row>
      <md-table-row
        v-for="usuario in searched"
        :key="usuario.id"
        class="pt-2 pb-2"
      >
        <md-table-cell>{{ usuario.userName }}</md-table-cell>
        <md-table-cell>{{ usuario.nomeCompleto }}</md-table-cell>
        <md-table-cell>{{ usuario.email }}</md-table-cell>
        <md-table-cell>
          {{ usuario.roles.map((e) => roleToText(e)).join(', ') }}
        </md-table-cell>
        <md-table-cell>
          <md-switch
            v-model="usuario.bloqueado"
            :disabled="usuario.roles.includes('Admin')"
            @change="() => alterarBlockUsuario(usuario)"
          >
            Block
          </md-switch>
        </md-table-cell>
        <md-table-cell>
          <div class="row" style="justify-content: flex-start">
            <md-menu md-size="medium" md-align-trigger>
              <md-button md-menu-trigger> Ações</md-button>

              <md-menu-content>
                <md-menu-item>
                  <md-button
                    class="md-primary"
                    @click.prevent="
                      $router.push({
                        name: 'usuariosEditar',
                        params: { userId: usuario.id },
                      })
                    "
                  >
                    Editar
                  </md-button>
                </md-menu-item>
                <md-menu-item>
                  <md-button
                    class="md-primary"
                    @click.prevent="editarSenha(usuario.id)"
                  >
                    Trocar senha
                  </md-button>
                </md-menu-item>
                <md-menu-item>
                  <md-button
                    class="md-accent"
                    @click.prevent="
                      activeModalDelete[usuario.id] = true
                      $forceUpdate()
                    "
                  >
                    Deletar
                  </md-button>
                </md-menu-item>
              </md-menu-content>
            </md-menu>

            <md-dialog-confirm
              :md-backdrop="true"
              :md-active.sync="activeModalDelete[usuario.id]"
              md-title="Tem certeza?"
              md-content="Deletar um usuário é uma ação irreversível. Após concluída os dados do usuário não poderão ser recuperados"
              md-confirm-text="deletar"
              md-cancel-text="cancelar"
              @md-clicked-outside="
                activeModalDelete[usuario.id] = false
                $forceUpdate()
              "
              @md-cancel="
                activeModalDelete[usuario.id] = false
                $forceUpdate()
              "
              @md-confirm="deletar(usuario.id)"
            />
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <loading :loading="loading" :diameter="200" />
  </div>
</template>

<script>
import { roleToText } from '@/utils/auth'

import Loading from '../../components/Loading.vue'
import http from '../../utils/http'

const toLower = (text) => {
  return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(item.userName).includes(toLower(term))
    )
  }

  return items
}

export default {
  name: 'UsuariosNovo',
  components: { Loading },
  data() {
    return {
      usuarios: [],
      locais: [],
      searched: [],
      search: null,
      active: false,
      loading: true,
      activeModalDelete: {},
      selectedLocais: [],
    }
  },
  async mounted() {
    await this.fetchData()
    this.searched = this.usuarios
  },
  methods: {
    roleToText,
    async alterarBlockUsuario(usuario) {
      await http.post('Accounts/user/block', {
        userId: usuario.id,
        block: usuario.bloqueado,
      })
    },
    searchOnTable() {
      this.searched = searchByName(this.usuarios, this.search)
    },
    searchOnTableLocais() {
      this.searched = this.usuarios.filter((user) => {
        return this.selectedLocais.every((localId) => {
          return user.userLocais.includes(localId)
        })
      })
    },
    editarSenha(userId) {
      this.$router.push({
        name: 'usuariosTrocarSenha',
        params: { userId: userId },
      })
    },
    async fetchUsuarios() {
      this.usuarios = await http.get('Accounts/user')
    },
    async fetchLocais() {
      this.locais = (await http.get('local')).locais
    },
    async fetchData() {
      this.loading = true

      await Promise.all([this.fetchUsuarios(), this.fetchLocais()]).finally(
        (e) => {
          this.loading = false
        }
      )
    },
    async deletar(id) {
      await http.delete('Accounts/user', id)
      await this.fetchData()
    },
  },
}
</script>

<style scoped></style>
